<template>
  <div>
    <!-- Breadcrumb -->
    <app-breadcrumb>
      <template #contentright>
        <b-button
          class="mr-1 btn-sm"
          variant="outline-primary"
          v-b-modal.showRelate1
        >
          <span class="text-nowrap">
            <feather-icon icon="PlusCircleIcon" /> {{ $t('Add New') }}
          </span>
        </b-button>
        <b-button
          class="mr-1 btn-sm"
          variant="outline-primary"
          v-b-modal.showMomo
        >
          <span class="text-nowrap">
            <feather-icon icon="DollarSignIcon" /> Nạp tiền qua momo
          </span>
        </b-button>
      </template>
    </app-breadcrumb>

    <!-- Filters -->
    <unit-buy-list-filters @search="searchAll" />

    <!-- Table Container Card -->
    <b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <b-card
        no-body
        class="mb-0"
      >
        <b-table
          ref="refUserListTable"
          class="position-relative table-nowrap"
          :items="itemsData"
          :fields="tableColumns"
          primary-key="id"
          :sort-by.sync="sortBy"
          responsive
          show-empty
          empty-text="Không tìm thấy kết quả"
          :sort-desc.sync="isSortDirDesc"
        >
          <template #cell(index)="data">
            {{ data.index + 1 }}
          </template>
          <template #cell(deposits)="row">
            {{ formatPrice(row.item.deposits) }}
          </template>
          <template #cell(surplus)="row">
            {{ formatPrice(row.item.surplus) }}
          </template>

          <!-- Column: Actions -->
          <template #cell(actions)="row">
            <b-button variant="outline-primary" @click="deposits(row.item)" class="ml-1 btn-icon" size="sm" v-b-tooltip.hover
              title="Nạp tiền">
              <feather-icon icon="DollarSignIcon" />
            </b-button>
            <b-button
              v-if="row.item.check_unit.length <= 1"
              size="sm"
              class="btn-icon ml-1"
              variant="outline-danger"
              @click="confirmDelete(row.item.id)"
            >
              <span class="text-nowrap">
                <feather-icon icon="TrashIcon" />
              </span>
            </b-button>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">{{
                $t('show_to_entries', {
                  from: dataMeta.from,
                  to: dataMeta.to,
                  of: dataMeta.of,
                })
              }}</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalEntries"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-overlay>
    <b-modal
      id="showRelate1"
      body-class=" mb-2"
      size="sm"
      @close="dialog"
      cancel-variant="outline-secondary"
      no-close-on-backdrop
      hide-footer
      :title="editMode ? 'Cập nhật' : 'Thêm mới'"
    >
      <unit-buy-create
        :mdata="frmData"
        @updateData="handleDialog"
      />
    </b-modal>
    <b-modal
      id="showDeposits"
      body-class=" mb-2"
      size="sm"   
      cancel-variant="outline-secondary"
      no-close-on-backdrop
      hide-footer
      title="Nạp tiền"
    >
      <unit-buy-deposits
        :mdata="frmData"
        @updateData="handleDialog"
      />
    </b-modal>
    <b-modal
      id="showMomo"
      body-class=" mb-2"
      size="sm"   
      cancel-variant="outline-secondary"
      no-close-on-backdrop
      hide-footer
      title="Nạp tiền"
    >
      <unit-buy-momo
        :mdata="frmData"
        @updateData="handleDialog"
      />
    </b-modal>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { required, email, alphaNum, min, max } from '@validations';
import {
  BOverlay,
  BCard,
  BRow,
  BCol,
  BButton,
  BTable,
  BFormCheckbox,
  BBadge,
  BPagination,
  BModal,
  BFormGroup,
  BFormTextarea,
  BFormInput,
  BForm,
  BFormInvalidFeedback,
  BLink,
  VBTooltip,
} from 'bootstrap-vue';
import { ref } from '@vue/composition-api';
import { showToast } from '@/@core/utils/utils';
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue';
import UnitBuyListFilters from './UnitBuyListFilters.vue';
import useUnitBuy from './useUnitBuy';
import formValidation from '@core/comp-functions/forms/form-validation';
import store from '@/store';
import UnitBuyCreate from './UnitBuyCreate.vue';
import UnitBuyMomo from './UnitBuyMomo.vue';
import UnitBuyDeposits from './UnitBuyDeposits.vue';
import moment from 'moment';
import Ripple from 'vue-ripple-directive';
export default {
  components: {
    AppBreadcrumb,
    UnitBuyListFilters,
    BOverlay,
    BCard,
    BRow,
    BCol,
    BButton,
    BTable,
    BBadge,
    BPagination,
    BFormCheckbox,
    BModal,
    BFormGroup,
    BFormTextarea,
    BFormInput,
    ValidationProvider,
    ValidationObserver,
    BForm,
    BFormInvalidFeedback,
    BLink,
    UnitBuyCreate,
    UnitBuyDeposits,
    UnitBuyMomo,
  },
  data() {
    return {
      editMode: false,
    };
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  setup() {
    const isAddNewUserSidebarActive = ref(false);
    const blankData = {
      id: null,
      unit_id: null,
      unit_name: '',
      deposist: 0,
    };
    const btnSwitchStatus = ref(false);
    const frmData = ref(JSON.parse(JSON.stringify(blankData)));
    const resetfrmData = () => {
      frmData.value = JSON.parse(JSON.stringify(blankData));
    };
    const {
      loading,
      fetchAll,
      tableColumns,
      perPage,
      currentPage,
      totalEntries,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      itemsData,
      resolveStatusVariant,
      resolveStatusText,
    } = useUnitBuy();

    fetchAll();
    const { refFormObserver, getValidationState, resetForm } =
      formValidation(frmData);
    return {
      fetchAll,
      // Sidebar
      isAddNewUserSidebarActive,
      loading,
      tableColumns,
      perPage,
      currentPage,
      totalEntries,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      itemsData,
      frmData,
      getValidationState,
      resetfrmData,
      resolveStatusVariant,
      resolveStatusText,
      btnSwitchStatus,
    };
  },
  methods: {
    handleDialog() {
      this.$bvModal.hide('showRelate1');
      this.$bvModal.hide('showDeposits');
      this.fetchAll();
      this.resetfrmData();
    },
    dialog() {
      this.editMode = false;
      this.resetfrmData();
      this.$bvModal.show('showRelate1');
    },
    edit(item) {
      this.frmData = item;
      this.editMode = true;
      this.dialog_title = 'Cập nhật';
      this.$bvModal.show('showRelate1');
    },
    confirmDelete(id) {
      this.$swal({
        title: 'Bạn chắc muốn xóa?',
        text: 'Xóa dữ liệu sẽ ảnh hưởng đến các chức năng khác trong hệ thống!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Có',
        cancelButtonText: 'Không',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch('sellNews/destroyCategoryPrice', { id })
            .then((res) => {
              if (res.status === 200) {
                this.fetchAll();
                showToast(res.data.message, { variant: 'success' });
              } else {
                showToast(res.data.message);
              }
            });
        }
      });
    },
    changeStatus(item, status, msg, title) {
      console.log(!233);
      this.btnSwitchStatus = true;
      this.$store
        .dispatch('sellNews/changeStatusCategoryPrice', {
          id: item.id,
          status: status,
        })
        .then((res) => {
          if (res.status === 200) {
            this.fetchAll();
            showToast(res.data.message, { variant: 'success' });
          } else {
            showToast(res.data.message);
          }
          this.btnSwitchStatus = false;
        });
    },
    searchAll(data) {
      this.searchQuery.keyword = data.keyword;
      this.searchQuery.end_date = data.end_date;
      this.searchQuery.start_date = data.start_date;
      this.searchQuery.status = data.status;
      this.fetchAll();
    },
    formatPrice(price) {
      let val = price.toString();
      val = val.replace(/,/g, '');

      // eslint-disable-next-line eqeqeq
      if (+val != 0 && !+val) {
        return 0;
      } else {
        let subString = val.substring(0, 1);
        if (subString === 0 || subString === '0') {
          subString = val.substring(1);
        } else {
          subString = val;
        }
        const hT = subString.split('.');
        const head = hT[0].split('');
        if (head.length > 3) {
          let index = 3;
          while (head.length - index >= 1) {
            head.splice(head.length - index, 0, ',');
            index += 4;
          }
        }
        return hT.length > 1 ? `${head.join('')}.${hT[1]}` : head.join('');
      }
    },
    deposits(item) {
      this.frmData = item;
      this.$bvModal.show('showDeposits');
    },
  },
};
</script>
